// extracted by mini-css-extract-plugin
export var buttonContainer = "_89-1";
export var fontSizeSelect = "_89-3";
export var formatSelect = "_89-2";
export var formats = "_89-4";
export var hidden = "_89-5";
export var icon = "_89-6";
export var select = "_89-0";